import { createServerFn } from '@tanstack/react-start';
import { defineQuery } from 'groq';

import type { HowWeCompareAgentsQueryResult } from '@/sanity.types';

import { createSanityClient } from './client';
import { legalDocumentProjection } from './legal-document';

export type HowWeCompareAgents = NonNullable<HowWeCompareAgentsQueryResult>;

const howWeCompareAgentsQuery = defineQuery(`*[
  _type == "howWeCompareAgents" &&
  _id == "howWeCompareAgents"
][0] ${legalDocumentProjection}`);

/** Public server function: it only reads the published "How we compare agents" page from Sanity. */
export const getHowWeCompareAgents = createServerFn({ method: 'GET' }).handler(
  async (): Promise<HowWeCompareAgents | null> => {
    const client = createSanityClient();

    try {
      return await client.fetch(howWeCompareAgentsQuery);
    } catch (error) {
      console.error('Failed to load Sanity how we compare agents', error);
      return null;
    }
  },
);
